import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {TrackerModel, TrackerPayloadModel} from '@shared/models';

@Injectable({
  providedIn: 'root'
})
export class TrackerService {
  private readonly TRACKER_API = `api/portal/v3/user_interaction_events`;

  constructor(private http: HttpClient) {
  }

  trackActivity(model: TrackerModel): Observable<void> {
    let body: TrackerPayloadModel = {
      interaction_events: [model]
    };

    return this.http.post<void>(this.TRACKER_API, body);
  }

}
